/* Shopper-controlled pagination; normal links remain available after request failures. */
(function () {
  'use strict';

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function setState(box, state) {
    box.setAttribute('data-zk-state', state);
  }

  function say(box, message) {
    var status = qs(box, '[data-zk-more-status]');
    if (status) status.textContent = message;
  }

  function showLink(box) {
    box.className = box.className.replace(/\s*zk-more--auto/g, '');
    setState(box, 'idle');
    box.zkBusy = false;
  }

  function pause(box) {
    box.zkPaused = true;
    showLink(box);
  }

  function surrender(box, message) {
    box.zkOk = false;
    showLink(box);
    if (message) say(box, message);
  }

  function load(box) {
    if (!box.isConnected || !box.zkOk || box.zkBusy || box.zkPaused) return;

    var url = box.getAttribute('data-zk-next');
    if (!url) return;

    var grid = document.getElementById(box.getAttribute('data-zk-target') || 'product-grid');
    if (!grid) {
      surrender(box);
      return;
    }

    box.zkBusy = true;
    setState(box, 'loading');
    say(box, 'Loading more fragrances.');

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (!box.isConnected || document.getElementById(grid.id) !== grid) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.getElementById(box.getAttribute('data-zk-target') || 'product-grid');
        if (!incoming) throw new Error('no grid in response');

        var source = incoming.children;
        var pending = [];
        var i;
        for (i = 0; i < source.length; i++) pending.push(source[i]);
        if (!pending.length) throw new Error('empty page');

        var fragment = document.createDocumentFragment();
        for (i = 0; i < pending.length; i++) {
          fragment.appendChild(document.importNode(pending[i], true));
        }
        grid.appendChild(fragment);

        var nextBox = doc.querySelector('[data-zk-more]');
        var nextUrl = nextBox ? nextBox.getAttribute('data-zk-next') : '';

        box.zkBusy = false;

        if (nextUrl) {
          box.setAttribute('data-zk-next', nextUrl);
          var link = qs(box, '[data-zk-more-btn]');
          if (link) link.setAttribute('href', nextUrl);
          pause(box);
        } else {
          box.removeAttribute('data-zk-next');
          setState(box, 'done');
        }

        say(box, pending.length + ' more fragrances loaded.');
      })
      .catch(function () {
        surrender(box, 'Could not load more fragrances. Use the link to continue.');
      });
  }

  function init(scope) {
    var box = qs(scope || document, '[data-zk-more]');
    if (!box || box.zkBound) return;
    box.zkBound = true;

    if (!window.fetch || !window.DOMParser) return;

    box.zkOk = true;
    box.zkPaused = true;

    var link = qs(box, '[data-zk-more-btn]');
    if (link) {
      link.addEventListener(
        'click',
        function (event) {
          // Once surrender() has run this handler stands aside and lets the
          // link navigate, so a failed fetch still leaves a way to page two.
          if (!box.zkOk) return;
          event.preventDefault();

          box.zkPaused = false;
          box.className += ' zk-more--auto';
          load(box);
        },
        false
      );
    }

  }

  function start() {
    init(document);

    var container = document.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      new MutationObserver(function () {
        init(container);
      }).observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, false);
  } else {
    start();
  }
})();
